import { render } from "./LogrosES.vue?vue&type=template&id=4f7223de&scoped=true"
import script from "./LogrosES.vue?vue&type=script&lang=js"
export * from "./LogrosES.vue?vue&type=script&lang=js"

import "./LogrosES.vue?vue&type=style&index=0&id=4f7223de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7223de"]])

export default __exports__